import { Col, Glyphicon, Panel } from 'react-bootstrap';
import { DocumentContainer, DocumentButton, PanelBodyWrapper, FormSection } from '../styles';
import { FormGroupWrapper } from '@nkr/views/donors/donor-intake/styles';

interface IProps {
    hasAboResults: boolean,
    onDownloadFile: () => void,
    onGetQuestionaireReport: () => void
}

const Documents: React.FC<IProps> = ({ hasAboResults, onDownloadFile, onGetQuestionaireReport }) => {
    return (
        <Panel>
            <Panel.Heading>Documents</Panel.Heading>
            <PanelBodyWrapper>
                <FormSection>
                    <FormGroupWrapper>
                        <Col xs={12} lg={12}>
                            <DocumentContainer>
                                <DocumentButton
                                    bsStyle='primary'
                                    onClick={onGetQuestionaireReport}
                                >
                                    <div className='button-content'>
                                        <Glyphicon glyph='file-text' />
                                            Download Questionnaire
                                        </div>
                                    <Glyphicon glyph='cloud-download' className='status-icon' />
                                </DocumentButton>

                                <DocumentButton
                                    bsStyle='primary'
                                    onClick={onDownloadFile}
                                    disabled={!hasAboResults}
                                >
                                    <div className='button-content'>
                                        {hasAboResults ? 'Download ABO Results' : 'Pending ABO Results'}
                                    </div>
                                    {hasAboResults ?
                                        <Glyphicon glyph='cloud-download' className='status-icon' />
                                        :
                                        <Glyphicon glyph='time' className='status-icon' />
                                    }
                                </DocumentButton>
                            </DocumentContainer>
                        </Col>
                    </FormGroupWrapper>
                </FormSection>
            </PanelBodyWrapper>
        </Panel>
    );
}

export default Documents;